import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { styled } from '@mui/material';
import React from 'react'

const LoadingButtonStyled = styled(LoadingButton)<LoadingButtonProps>(
  ({ theme }) => ({
    borderRadius: 10,
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: "Open Sans",
    padding: 20,
    textTransform: "none",
  })
);
  

export default LoadingButtonStyled;